import type { Meta, StoryObj } from "@storybook/react";

import type { ActionBarProps } from "@/ui/core";
import { ActionBar, FAIconName } from "@/ui/core";

const StoryMeta: Meta<ActionBarProps> = {
  title: "Core/Action Bar",
  component: ActionBar,
  argTypes: {
    iconName: {
      control: "select",
      options: Object.values(FAIconName),
    },
    message: { control: "text" },
    size: {
      control: "select",
      options: ["small", "medium"],
    },
    variant: {
      control: "select",
      options: ["critical", "info", "primary", "warning"],
    },
  },
  args: {
    iconName: FAIconName.InfoCircle,
    message:
      "For this particular group, the patient will need\nto register via their own account.",
    size: "small",
    variant: "primary",
  },
};

type Story = StoryObj<ActionBarProps>;

export const Primary: Story = {};
export default StoryMeta;
